import React from 'react';
import { Gamepad2, Code2, BrainCircuit, Rocket, Trophy } from 'lucide-react';
export function MechanismSection() {
  const steps = [{
    icon: <Gamepad2 className="h-8 w-8" data-id="element-112" />,
    title: 'Etapa 1: El Jugador',
    desc: 'Entendemos su motivación actual.'
  }, {
    icon: <BrainCircuit className="h-8 w-8" data-id="element-113" />,
    title: 'Etapa 2: El Analista',
    desc: 'Desglosamos cómo funcionan sus juegos.'
  }, {
    icon: <Code2 className="h-8 w-8" data-id="element-114" />,
    title: 'Etapa 3: El Constructor',
    desc: 'Primeros pasos en la lógica de código.'
  }, {
    icon: <Rocket className="h-8 w-8" data-id="element-115" />,
    title: 'Etapa 4: El Ingeniero',
    desc: 'Sistemas complejos y variables.'
  }, {
    icon: <Trophy className="h-8 w-8" data-id="element-116" />,
    title: 'Etapa 5: El Creador',
    desc: 'Publicación de su primer proyecto.'
  }];
  return <section className="py-12 md:py-16 bg-[#050810] relative overflow-hidden" data-id="element-117">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#00d4aa]/5 rounded-full blur-[100px] pointer-events-none" data-id="element-118" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-119">
        <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-120">
          <span className="text-[#00d4aa] font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-121">
            La Solución
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-122">
            Presentamos el{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00d4aa] to-blue-500" data-id="element-123">
              "Puente Creador"
            </span>
          </h2>
          <p className="text-lg text-gray-300 leading-relaxed" data-id="element-124">
            Un sistema de 5 etapas diseñado específicamente para padres
            no-técnicos. En lugar de luchar contra Roblox o Minecraft, usamos
            esas plataformas como laboratorios de ingeniería. Tu hijo aprende
            lógica de programación, variables y eventos mientras construye los
            niveles que él mismo juega. No es tarea; es el "detrás de cámaras"
            de su pasión.
          </p>
        </div>

        {/* Steps Visual */}
        <div className="relative" data-id="element-125">
          {/* Connecting Line (Desktop) */}
          <div className="hidden lg:block absolute top-1/2 left-0 w-full h-1 bg-gray-800 -translate-y-1/2 z-0" data-id="element-126"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8" data-id="element-127">
            {steps.map((step, idx) => <div key={idx} className="relative z-10 group" data-id="element-128">
                <div className="bg-[#111827] border border-gray-700 rounded-xl p-6 h-full flex flex-col items-center text-center transition-all duration-300 hover:border-[#00d4aa] hover:shadow-[0_0_20px_rgba(0,212,170,0.2)] hover:-translate-y-2" data-id="element-129">
                  <div className="w-16 h-16 rounded-full bg-[#0a0e1a] border-2 border-[#00d4aa] flex items-center justify-center text-[#00d4aa] mb-4 shadow-[0_0_15px_rgba(0,212,170,0.3)] group-hover:scale-110 transition-transform" data-id="element-130">
                    {step.icon}
                  </div>
                  <h3 className="text-lg font-bold text-white mb-2" data-id="element-131">
                    {step.title}
                  </h3>
                  <p className="text-sm text-gray-400" data-id="element-132">{step.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}